var map = {
	"./black/duofanghuiyi.png": "1H7C",
	"./blue/duofanghuiyi.png": "FeS9",
	"./white/duofanghuiyi.png": "h6XT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Tdz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duofanghuiyi\.png$
// module id = 1Tdz
// module chunks = 24